export const EXPLORER = 'explorer';
export const VIEWS = 'views';
export const DASHBOARDS = 'dashboards';
export const MAP = 'map';
export const ALERTS = 'alerts';
export const TEAM = 'team';
export const HOME = 'home';
export const BILLING = 'billing';
export const SETTINGS = 'settings';
export const CREDITS = 'credits';
export const CANCEL_PLAN = 'cancel_plan';
export const REPORT = 'reports';
